import { authGuard } from '@/services/Authentication/authGuard';
import ApplicationComponent from '@/views/broker/Applications/index.vue';
import BrokerComponent from '@/views/broker';
import BrokerListComponent from '@/views/broker/Brokers/index.vue';
import ContactComponent from '@/views/broker/Contact/index.vue';
import DashboardComponent from '@/views/broker/Dashboard/index.vue';
import DashboardMainComponent from '@/views/broker/Dashboard/Main.vue';
import KnowledgeBase from '@/views/broker/KnowledgeBase/index.vue';
import LoanComponent from '@/views/broker/Applications/LoanComponent.vue';
import ProgressAndSummary from '@/views/broker/Progress-Summary/index.vue';
import ServicingCalculator from '@/views/broker/ServicingCalculator/index.vue';
// import SettingsComponent from '@/views/broker/Settings/index.vue';
import Summary from '@/views/broker/Progress-Summary/Summary/SummaryIndex.vue';

export const BrokerRoutes = [
  {
    path: '/',
    component: BrokerComponent,
    children: [
      {
        path: 'application',
        component: LoanComponent,
        name: 'Application',
        beforeEnter: authGuard,
        children: [
          {
            path: '',
            component: ApplicationComponent,
            name: 'ApplicationList',
          },
          {
            path: 'progress/:id',
            component: ProgressAndSummary,
            name: 'ProgressAndSummary',
          },
          {
            path: 'summary/:id',
            component: Summary,
            name: 'Summary',
          },
        ],
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        name: 'Dashboard',
        beforeEnter: (to, from, next) => {
          const { userType } = JSON.parse(localStorage.getItem('vuex')) ?? {};
          if (userType === 'broker_assistant') {
            return next('/brokers');
          }
          return authGuard(to, from, next);
        },
        children: [
          {
            path: 'servicing-calculator',
            component: ServicingCalculator,
            name: 'ServicingCalculator',
          },
          {
            path: '',
            component: DashboardMainComponent,
            name: 'DashboardMainComponent',
          },
        ],
      },
      {
        path: 'brokers',
        component: BrokerListComponent,
        name: 'Brokers',
        beforeEnter: (to, from, next) => {
          const { userType } = JSON.parse(localStorage.getItem('vuex')) ?? {};
          if (userType !== 'broker_assistant') {
            return next('/dashboard');
          }
          return authGuard(to, from, next);
        },
      },
      {
        path: 'knowledge-hub',
        component: KnowledgeBase,
        name: 'KnowledgeBase',
        beforeEnter: authGuard,
      },
      {
        path: '/contact',
        component: ContactComponent,
        name: 'Contact',
        beforeEnter: authGuard,
      },
      /*
      {
        path: '/settings',
        component: SettingsComponent,
        name: 'Settings',
        beforeEnter: authGuard,
      },
      */
    ],
  },
];

export default BrokerRoutes;
